import { ApolloError } from '@shared/apollo';

import type { PublishValidationError } from './types';

export function transformItemSetPublicationErrors(error: unknown) {
  if (!(error instanceof ApolloError)) {
    return [];
  }

  const extensions = error.cause?.extensions;
  if (!extensions || typeof extensions !== 'object' || Array.isArray(extensions)) {
    return [];
  }

  const details = extensions.details as PublishValidationError[] | undefined;

  if (!Array.isArray(details)) {
    return [];
  }

  return details;
}
